import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core'

import { ChannelReviewSearchParams, ChannelReviewSources, ChannelReviewsResponse } from '@tokeet-frontend/reviews'
import { ChannelNameTokens } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'

import * as moment from 'moment'

@Component({
  selector: 'app-reviews-stats',
  templateUrl: './reviews-stats.component.html',
  styleUrls: ['./reviews-stats.component.scss'],
})
export class ReviewsStatsComponent implements OnInit {
  @Input() data: ChannelReviewsResponse
  @Input() filters: ChannelReviewSearchParams

  @Output() sourceChange = new EventEmitter<string>()
  sources = ChannelReviewSources
  channelNames = ChannelNameTokens

  get lastXDays() {
    const start = this.filters?.submittedAfter
    const end = this.filters?.submittedBefore
    if (!start || !end) {
      return ''
    }

    return `in ${moment(end * 1000).diff(start * 1000, 'day') + 1} days`
  }
  get totalAvarageRating() {
    const total = Object.keys(this.data?.averageRating || {}).length
    if (!total) return 0
    return lodash.sumBy(lodash.values(this.data?.averageRating), (t) => t.averageRating || 0) / total
  }

  source: string
  constructor() {}

  ngOnInit(): void {}

  onChangeSource(s: string) {
    this.source = s
    this.sourceChange.emit(s)
  }
}
